import React, { useMemo } from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

// models
import { FieldType } from '@karehero/models';

// components
import { Editor } from '@/components/organisms/Editor/Editor';
import { createFieldHelper } from '@/components/organisms/EditorFields/fieldHelper';

export interface Contact {
  firstName: string;
  lastName: string;
  phoneNumber: string;
  email: string;
}

const fields = createFieldHelper<Contact>({
  firstName: {
    label: 'First name',
    field: {
      type: FieldType.Text,
    },
  },
  lastName: {
    label: 'Last name',
    field: {
      type: FieldType.Text,
    },
  },
  phoneNumber: {
    label: 'Phone number',
    field: {
      type: FieldType.Text,
    },
  },
  email: {
    label: 'Email',
    field: {
      type: FieldType.Text,
    },
  },
});

/**
 * ContactField allows you to add a contact field to your form.
 */
export const ContactField = ({ label, value, onChange }: ContactFieldProps) => {
  // memo
  const contact = useMemo(() => {
    let c: Partial<Contact> = {};
    try {
      c = JSON.parse(value || '{}');
    } catch (e) {
      console.error(e);
    }
    return c;
  }, [value]);

  return (
    <Stack sx={{ gap: '16px' }}>
      <Box sx={{ typography: 'bodyLg', color: '#000000' }}>{label}</Box>
      <Editor
        fields={fields}
        value={contact}
        onChange={(val) => onChange(JSON.stringify(val))}
        isFloatingActions={false}
        isActionsDisabled={true}
        isForm={false}
      />
    </Stack>
  );
};

interface ContactFieldProps {
  label?: string;
  value: string;
  onChange: (value: string) => void;
}

ContactField.displayName = 'ContactField';

export default ContactField;
